<template>
  <div class="photos_page">
    <div class="ma-10">
      <div class="text-center">
        <v-dialog v-model="dialog" max-width="600" overlay-opacity="0.95">
          <template v-slot:activator="{ on }">
            <v-row>
              <v-col
                cols="12"
                sm="6"
                offset-sm="3"
                v-for="(group, z) in groupingPhotos"
                :key="z"
              >
                <v-row>{{ group.date == "" ? "－" : group.date }}</v-row>
                <v-row>
                  <v-col
                    v-for="(item, i) in group.child"
                    :key="i"
                    class="d-flex child-flex"
                    cols="4"
                  >
                    <v-card
                      flat
                      tile
                      class="d-flex"
                      v-on="on"
                      @click="active = item.index"
                    >
                      <v-img
                        :src="item.url"
                        aspect-ratio="1"
                        class="grey lighten-2"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>

          <div>
            <div
              style="font-size: 14px;color: #fff;
    text-align: center;"
            >
              {{ activeTitle }}
            </div>
            <div
              style="
       text-align: right;
    margin-top: -20px;
    padding-right: 2px;
    
"
            >
              <v-btn icon @click="dialog = false" small style="z-index: 1;">
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </div>
            <v-carousel
              v-model="active"
              :show-arrows-on-hover="true"
              hide-delimiters
              :continuous="false"
            >
              <v-carousel-item
                v-for="(item, i) in photos"
                :key="i"
                :active-class="activeClass"
                reverse-transition="fade-transition"
                transition="fade-transition"
                style="text-align: center;"
              >
                <img
                  border="0"
                  :src="item.url"
                  style="width:100%;position: absolute;top: 50%;left: 50%;transform: translateY(-50%) translateX(-50%);-webkit- transform: translateY(-50%) translateX(-50%);"
                  :style="imageStyle"
                />
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import firestore from "@/js/firebase";

// import firestore from "@/js/firebase.js";
//const memoRef = firestore.collection("photo");
export default {
  name: "Histry",
  data: () => ({
    dialog: false,
    active: null,
    items: [],
    photos: [],
    groupingPhotos: [],
    fileBasePath: "",
    imageStyle: "opacity: 0;",
    activeDisped: null,
  }),
  computed: {
    activeTitle: function() {
      if (this.active == null) {
        return "";
      }

      const date = this.photos[this.active].date;
      return (
        this.photos[this.active].title +
        (date == "" ? "" : " (" + this.photos[this.active].date + ")")
      );
    },
    activeClass: function() {
      if (this.active == null) {
        return "";
      } else {
        return this.active.toString();
      }
    },
  },
  watch: {
    active: function(val) {
      var img = new Image();

      img.onload = () => {
        if (img.height > 500) this.imageStyle = "max-width:300px";
      };
      img.src = this.photos[val].url;
      if (this.activeDisped != val) this.imageStyle = "";
      this.activeDisped = val;
    },
  },
  created() {
    this.get();
  },
  methods: {
    get: function() {
      const s = this;
      firestore
        .collection("photos")
        .get()
        .then(function(querySnapshot) {
          s.photos = [];
          querySnapshot.forEach(function(doc) {
            let data = doc.data();
            data.id = doc.id;
            s.photos.push(data);
          });
          s.getPhoto();
        });
    },
    getPhoto: function() {
      const s = this;
      const storageRef = firebase.storage().ref();
      const imagesRef = storageRef.child("photo");
      const dummyFileName = "dummy";
      const spaceRef = imagesRef.child(dummyFileName);
      spaceRef.getDownloadURL().then(function(url) {
        s.fileBasePath = url;
        for (let i = 0; i < s.photos.length; i++) {
          const fileName = s.photos[i].fileName;
          s.photos[i].url = s.fileBasePath.replace("dummy", fileName);
        }
        let group = s.photos.reduce(function(result, current) {
          let element = result.find(function(p) {
            return p.date === current.date;
          });
          if (element) {
            element.child.push(current);
          } else {
            result.push({
              date: current.date,
              child: [current],
            });
          }
          return result;
        }, []);
        group.sort(function(a, b) {
          if (a.date < b.date) return 1;
          if (a.date > b.date) return -1;
          return 0;
        });
        let indexCount = 0;
        group.forEach((element) => {
          element.child.sort(function(a, b) {
            if (a.fileName < b.fileName) return -1;
            if (a.fileName > b.fileName) return 1;
            return 0;
          });
          element.child.forEach((chil) => {
            chil.index = indexCount;
            s.photos.filter(
              (item) => item.id === chil.id
            )[0].index = indexCount;
            indexCount++;
          });
        });
        s.photos.sort(function(a, b) {
          if (a.index < b.index) return -1;
          if (a.index > b.index) return 1;
          return 0;
        });
        s.groupingPhotos = group;
      });
    },
    remove: function(x) {
      const s = this;
      firestore
        .collection("photos")
        .doc(x.id)
        .delete()
        .then(function() {
          s.get();
        });
    },
  },
};
</script>
<style scoped>
div >>> .v-dialog {
  overflow: hidden !important;
}
div >>> .v-dialog {
  box-shadow: none;
}
div >>> .v-window__next {
  background: none;
}
</style>
